import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { Modal } from './Modal';

const inputCls = 'w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/30 focus:outline-none focus:border-[#7dd3fc]/50 transition-colors';

export const QuoteModal = ({ open, onClose, products = [] }) => {
  const [form, setForm] = useState({ name: '', product: '', quantity: '' });

  useEffect(() => {
    if (open && !form.product && products.length > 0) {
      const first = products.find((p) => p.available) || products[0];
      setForm((f) => ({ ...f, product: first.name }));
    }
  }, [open, products, form.product]);

  const submit = (e) => {
    e.preventDefault();
    const text = `Olá, meu nome é ${form.name}. Gostaria de uma cotação para ${form.product} - Quantidade: ${form.quantity}.`;
    window.open(`https://wa.me/5511981919933?text=${encodeURIComponent(text)}`, '_blank');
    setForm({ name: '', product: '', quantity: '' });
    onClose();
  };

  const change = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Solicitar Cotação"
      subtitle="Preencha os dados e continuaremos pelo WhatsApp."
      testId="quote-modal"
    >
      <form onSubmit={submit} className="space-y-4">
        <input required placeholder="Seu nome" value={form.name} onChange={change('name')} className={inputCls} data-testid="quote-name-input" />
        <select required value={form.product} onChange={change('product')} className={`${inputCls} appearance-none`} data-testid="quote-product-select">
          <option value="" disabled>Selecione o produto</option>
          {products.map((p) => (
            <option key={p.id} value={p.name} className="bg-[#0a1628]">{p.name} ({p.weight})</option>
          ))}
        </select>
        <input required type="text" placeholder="Quantidade (ex.: 50 unidades)" value={form.quantity} onChange={change('quantity')} className={inputCls} data-testid="quote-quantity-input" />
        <motion.button
          type="submit"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className="w-full py-3.5 bg-gradient-to-r from-[#25D366] to-[#128C7E] text-white font-bold rounded-xl shadow-lg flex items-center justify-center gap-2"
          data-testid="quote-submit-btn"
        >
          <MessageCircle size={18} />
          <span>Enviar via WhatsApp</span>
        </motion.button>
      </form>
    </Modal>
  );
};
